export default {"LABEL":"Md Social 图标","DESC":"来自 MATERIAL DESIGN 的图标库.","COMPONENTS":{"__markdown":true}}